import { convertDateFormat } from "../../utils/Converters/convertDateFormat";
import { useReactToPrint } from "react-to-print";

export const usePrintHandler = (componentRef) => {
  return useReactToPrint({
    content: () => componentRef.current,
    pageStyle: `
      @media print { 
        @page { 
          size: A4 portrait; 
          margin: 5mm;
          marks: none;
        }
        body { 
          -webkit-print-color-adjust: exact; 
          margin: 0 !important;
        }
        .print-hide { 
          display: none !important; 
        }
      }
    `,
    removeAfterPrint: true,
  });
};

export const getEmployeeDetails = (data) => [
  {
    label1: "Employee Name",
    value1: data?.employee_name,
    label2: "Employee ID",
    value2: data?.employee_id,
  },
  {
    label1: "Designation",
    value1: data?.role,
    label2: "Department",
    value2: data?.department,
  },
  {
    label1: "Date of Joining",
    value1: convertDateFormat(data?.joining_date),
    label2: "Fixed Monthly Salary",
    value2: data?.payslip?.fixed_salary,
  },
  {
    label1: "Worked Days",
    value1: `${data?.payslip?.worked_days} Days`,
  },
];

export const getPayslipDetails = (data, netSalaryDetails) => ({
  earnings: [
    {
      label: "Fixed Salary for the Month",
      value: data?.payslip?.fixed_salary_for_the_month,
    },

    {
      label: "Transport Allowances",
      value: data?.payslip?.transport_allowances,
      total: netSalaryDetails?.allowances,
    },
  ],
  deductions: [
    { label: "Fines", value: data?.payslip?.fines },
    { label: "Salik", value: data?.payslip?.salik },
    { label: "Telephone", value: data?.payslip?.telephone },
    { label: "Loan Taken", value: data?.payslip?.loan_taken },
    { label: "Salary Advance", value: data?.payslip?.salary_advance },
    {
      label: "Others",
      value: data?.payslip?.others_deduction,
      total: netSalaryDetails?.deductions,
      remarks: data?.payslip?.deduction_remarks,
    },
  ],
  additions: [
    {
      label: "Transport Extra Usage",
      value: data?.payslip?.transport_extra_usage,
    },
    { label: "Leave Salary", value: data?.payslip?.leave_salary },
    { label: "Overtime", value: data?.payslip?.overtime },
    { label: "Comp off", value: data?.payslip?.compo_off },
    { label: "Commission", value: data?.payslip?.commission },
    {
      label: "Additional Allowances",
      value: data?.payslip?.additional_allowances,
    },
    {
      label: "Others",
      value: data?.payslip?.other_allowance,
      total: netSalaryDetails?.totalAdditions,
    },
  ],
});
